import { useState, useEffect } from 'react';
import photocarrousel1 from '../asstes/photocarrousel1.avif';
import photocarrousel2 from '../asstes/photo-caroussel2.avif';
import photocarrousel3 from '../asstes/photo-caroussel3.avif';
import photocarrousel4 from "../asstes/photocaroussel4.avif"
import '../App.css';

const images = [photocarrousel1, photocarrousel2, photocarrousel3, photocarrousel4];

const Header = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="hero-section">
      <img
        src={images[currentIndex]}
        alt="cabinet de dentiste de severine"
        className="hero-image"
      />
      <div className="overlay"></div>
      <div className="hero-text">
        <h1>Severine Raad Dentiste</h1>
      </div>
    </header>
  );
};

export default Header;
